const actions = {
  GET_WAITERS_REQUEST: "GET_WAITERS_REQUEST",
  GET_WAITERS_SUCCESS: "GET_WAITERS_SUCCESS",
  FILTER_BY_WAITERS_REQUEST: "FILTER_BY_WAITERS_REQUEST",
  FILTER_BY_WAITERS_SUCCESS: "FILTER_BY_WAITERS_SUCCESS",

  getWaiters: (restaurantId) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_WAITERS_REQUEST,
        restaurantId,
      });
    };
  },

  getTurnOverByWaiters: (
    filteredWaiterIds,
    startDate,
    endDate,
    selectedRestaurant
  ) => {
    return (dispatch) => {
      dispatch({
        type: actions.FILTER_BY_WAITERS_REQUEST,
        filteredWaiterIds,
        startDate,
        endDate,
        selectedRestaurant,
      });
    };
  },
};
export default actions;
